export const  defaultSelectedDateUp  = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const defaultSelectedDateFrom = () => {
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    const year = oneMonthAgo.getFullYear();
    const month = (oneMonthAgo.getMonth() + 1).toString().padStart(2, '0');
    const day = oneMonthAgo.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;

};

export default {
    loading: {
        module: false
    },
    params: {
        provider_id: null
    },
    params_query:{
        is_customer: false,
        is_provider: true,
        is_employee: false,
        query: '',
        sort: 'ASC',
    },
    contacts: [],
    reportInventoryReplacementDetail: [],
    reportInventoryReplacement: [],
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    }
}



// WEBPACK FOOTER //
// ./src/modules/report-inventory-replacement/state.js